import { Container } from '@plone/components';
import PersonMetadata from '../../Person/PersonMetadata';

const PersonMetadataView = (props) => {
  const hasMetadata = true;

  return (
    <div className="block person-metadata ">
      {hasMetadata && (
        <Container className="details-container">
          <PersonMetadata {...props} />
        </Container>
      )}
    </div>
  );
};

export default PersonMetadataView;
